import { render, staticRenderFns } from "./PersonModel.vue?vue&type=template&id=0587e69c&scoped=true&"
import script from "./PersonModel.vue?vue&type=script&lang=js&"
export * from "./PersonModel.vue?vue&type=script&lang=js&"
import style0 from "./PersonModel.vue?vue&type=style&index=0&id=0587e69c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587e69c",
  null
  
)

export default component.exports